import React, { Component } from 'react'
import ListReferraAnalytics from '../../Services/Queries/ListReferraAnalytics'
import { Button, Modal, Table } from 'react-bootstrap'
import { Auth } from 'aws-amplify'
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import { DateRangePicker } from 'react-date-range'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import _ from 'lodash'
import { referralUserSignupsHeadings } from '../Data/StaticData'
const styles = {
	fontSize: {
		fontSize: '12px',
	},
}

class ReferralUserSignups extends React.Component {
	toastStyle = {
		position: 'top-right',
		autoClose: 2000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	}
	constructor(props) {
		super(props)

		this.state = {
			selectionRange: {
				startDate: new Date(new Date().setHours(0, 0, 0, 0)),
				endDate: new Date(new Date().setHours(23, 59, 59, 999)),
				key: 'selection',
			},
			showDatePicker: false,
			referralUsersList: [],
			limit: 50,
			nextToken: null,
			render: false,
			endReached: false,
			loadMore: false,
			props: props,
			userDetails: {},
			userPermissions: [],
			currentPage: 1,
			filtered: false,
			headings: referralUserSignupsHeadings,
			loggedInUserPermissions: [],
			mobileNumbers: [],
			selectedMobileNumber: '',
			datesChanged: false,
		}

		this.loadMore = this.loadMore.bind(this)
	}
	loadMore = async () => {
		await this.getNextReferralUsersList()
	}
	getReferralUsersList = async () => {
		const { limit } = this.state
		const input = {
			limit: limit,
			nextToken: null,
		}
		console.log(input, 'input firstt========')
		const referralUsersList = await ListReferraAnalytics(input)
		console.log(referralUsersList, 'referralUsersList=====')
		const permissionInput = {
			mobileNumber: Auth.user.attributes.phone_number,
		}
		const userPermissions = await GetUserPermissions(permissionInput)
		let permissions = []
		let permissionsArr = []
		if (userPermissions && userPermissions.userRolesAndPermissions) {
			userPermissions.userRolesAndPermissions.map((item) => {
				permissions.push(...item.permissions)
			})
			permissions.map((permission) => {
				permissionsArr.push(permission.name)
			})
		}
		let mobileNumbers = []

		referralUsersList.items.map((data, index) => {
			mobileNumbers.push(data.mobileNumber)
		})
		this.setState({
			nextToken: referralUsersList.nextToken,
			referralUsersList: referralUsersList.items,
			loggedInUserPermissions: permissionsArr,
			mobileNumbers,
		})
	}
	getNextReferralUsersList = async () => {
		const { selectionRange, limit } = this.state
		const input = {
			limit: limit,
			nextToken: this.state.nextToken,
		}
		const epochStartTime = selectionRange.startDate.getTime()
		const epochEndTime = selectionRange.endDate.getTime()
		const startTime = Math.trunc(epochStartTime / 1000)
		const endTime = Math.trunc(epochEndTime / 1000)

		if (this.state.datesChanged) {
			input['filterBy'] = 'time'
			input['fromTime'] = startTime
			input['toTime'] = endTime
		} else if (this.state.datesChanged && this.state.selectedMobileNumber) {
			input['filterBy'] = 'mobileNumberAndTime'
			input['fromTime'] = startTime
			input['toTime'] = endTime
			input['mobileNumber'] = '+91' + this.state.selectedMobileNumber
		} else if (this.state.selectedMobileNumber) {
			input['filterBy'] = 'mobileNumber'
			input['mobileNumber'] = '+91' + this.state.selectedMobileNumber
		}
		console.log(input, 'inputttttttnextttttttt')
		const data = await ListReferraAnalytics(input)
		console.log(data, 'next dataaaaaaaaaaaaaaaaaaaa')
		const finalList = [...this.state.referralUsersList, ...data.items]
		let mobileNumbers = []
		finalList.map((data, index) => {
			mobileNumbers.push(data.mobileNumber)
		})
		if (data.nextToken == null) {
			this.setState({
				referralUsersList: finalList,
				nextToken: null,
				mobileNumbers,
			})
		} else {
			this.setState({
				referralUsersList: finalList,
				nextToken: data.nextToken,
				mobileNumbers,
			})
		}
	}

	componentDidMount = async () => {
		await this.getReferralUsersList()
	}

	renderTable = (heading, contentList) => {
		return (
			<Table striped bordered hover>
				<thead>
					<tr>
						{heading.map((head) => (
							<th style={{ fontSize: '14px', verticalAlign: 'middle', minWidth: '100px' }}>
								{head}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{contentList && contentList.map((row, index) => this.renderTableRow(row, index))}
				</tbody>
			</Table>
		)
	}
	getDateFormat = (time) => {
		const date = new Date(time * 1000)
		const formattedDate = this.getFormattedDate(date)
		return formattedDate
	}
	getFormattedDate = (date) => {
		var dd = date.getDate()
		var mm = date.getMonth() + 1

		var yyyy = date.getFullYear()
		if (dd < 10) {
			dd = '0' + dd
		}
		if (mm < 10) {
			mm = '0' + mm
		}
		var formattedDate = dd + '/' + mm + '/' + yyyy
		var hh = date.getHours()
		var m = date.getMinutes()
		var d = 'AM'
		var h = hh
		if (h >= 12) {
			h = hh - 12
			d = 'PM'
		}
		if (h == 0) {
			h = 12
		}
		m = m < 10 ? '0' + m : m
		const formattedTime = h + ':' + m + ' ' + d
		return formattedDate + ' ' + formattedTime
	}

	handleSelect = (dates) => {
		const start = new Date(dates.selection.startDate)
		start.setHours(0, 0, 0, 0)
		const end = new Date(dates.selection.endDate)
		end.setHours(23, 59, 59, 999)

		const dateObj = {
			startDate: start,
			endDate: end,
			key: 'selection',
		}

		this.setState({
			datesChanged: true,
			selectionRange: dateObj,
			showDatePicker: false,
		})
	}

	setSelectedMobileNumber = (e) => {
		this.setState({
			selectedMobileNumber: e.target.value,
		})
	}
	openDatePicker = () => {
		this.setState({ showDatePicker: true })
	}
	filterData = async () => {
		const { selectionRange, limit } = this.state
		const epochStartTime = selectionRange.startDate.getTime()
		const epochEndTime = selectionRange.endDate.getTime()
		const startTime = Math.trunc(epochStartTime / 1000)
		const endTime = Math.trunc(epochEndTime / 1000)
		const input = {
			limit: limit,
			nextToken: null,
		}
		if (this.state.datesChanged) {
			input['filterBy'] = 'time'
			input['fromTime'] = startTime
			input['toTime'] = endTime
		} else if (this.state.datesChanged && this.state.selectedMobileNumber) {
			input['filterBy'] = 'mobileNumberAndTime'
			input['fromTime'] = startTime
			input['toTime'] = endTime
			input['mobileNumber'] = '+91' + this.state.selectedMobileNumber
		} else if (this.state.selectedMobileNumber) {
			input['filterBy'] = 'mobileNumber'
			input['mobileNumber'] = '+91' + this.state.selectedMobileNumber
		}
		console.log(input, 'input firstt========')
		const referralUsersList = await ListReferraAnalytics(input)
		console.log(referralUsersList, 'referralUsersList=====')

		this.setState({
			filtered: true,
			nextToken: referralUsersList.nextToken,
			referralUsersList: referralUsersList.items,
		})
	}
	resetFilter = () => {
		this.setState({
			nextToken: null,
			selectedMobileNumber: '',
			filtered: false,
			datesChanged: false,
			selectionRange: {
				startDate: new Date(),
				endDate: new Date(),
				key: 'selection',
			},
		})
		this.getReferralUsersList()
	}

	renderTableRow = (item, index) => {
		return (
			<tr style={styles.fontSize}>
				<td>{index + 1}</td>
				{/* <td>{item.referralUUID}</td> */}
				<td>{this.getDateFormat(item.referralInstallTime)}</td>
				<td>{item.referralUserMobileNumber}</td>
				<td>{item.referralUserName}</td>
				<td>{item.referralUserHandle}</td>
				{/* <td>{item.referralURLType}</td>
        <td>{item.referralURL}</td>
        <td>{item.referralUserType}</td> */}
				<td>{item.referredByUUID}</td>
				<td>{item.referredByUserMobileNumber}</td>
				<td>{item.referredByUserName}</td>
				<td>{item.referredByUserHandle}</td>
			</tr>
		)
	}

	render() {
		const {
			referralUsersList,
			headings,
			selectionRange,
			showDatePicker,
			mobileNumbers,
		} = this.state
		return (
			<section className='feed'>
				<div>
					<label>Referral User Sign Ups</label>
				</div>
				<ToastContainer
					position='top-right'
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>
				{this.state.referralUsersList ? (
					<div>
						<div class='row'>
							<div class='col-md-4'>
								<text>Start Date : </text>
								<input
									type='text'
									onClick={() => {
										this.openDatePicker()
									}}
									value={this.getFormattedDate(selectionRange.startDate)}
									placeholder='Choose Start Date'
								></input>
							</div>

							<div class='col-md-4'>
								<text>End Date : </text>
								<input
									type='text'
									onClick={() => {
										this.openDatePicker()
									}}
									value={this.getFormattedDate(selectionRange.endDate)}
									placeholder='Choose End Date'
								></input>
							</div>
							<div class='col-md-2'>
								<Button
									disabled={
										!(
											this.state.datesChanged ||
											(this.state.selectedMobileNumber != '' &&
												this.state.selectedMobileNumber &&
												this.state.selectedMobileNumber.length == 10)
										)
									}
									style={{ marginRight: 10 }}
									onClick={() => {
										this.filterData()
									}}
								>
									Filter
								</Button>

								<Button
									onClick={() => {
										this.resetFilter()
									}}
								>
									Reset
								</Button>
							</div>
						</div>
						<div class='row'>
							<div class='col-md-6'>
								<text htmlFor='userName'> Mobile Number (With Referred By Mobile Number)</text>
								<div className='input-group '>
									<div className='input-group-prepend'>
										<span className='input-group-text'>+91</span>
									</div>
									<input
										type='text'
										className='form-control'
										value={this.state.selectedMobileNumber}
										placeholder='Enter Mobile Number'
										onChange={(e) => this.setSelectedMobileNumber(e)}
									/>
								</div>
								{this.state.selectedMobileNumber && this.state.selectedMobileNumber.length != 10 ? (
									<text for='text' style={{ color: 'red', fontSize: 10 }}>
										Mobile Number Should Be 10 digits
									</text>
								) : null}
							</div>
						</div>
						<div>
							{showDatePicker ? (
								<DateRangePicker ranges={[selectionRange]} onChange={this.handleSelect} />
							) : null}
						</div>

						<div style={{ marginTop: 10 }}>{this.renderTable(headings, referralUsersList)}</div>
					</div>
				) : (
					<div>No Data To Display</div>
				)}

				{this.state.nextToken != null && !this.state.filtered && (
					<Button onClick={this.loadMore} type='button' className='load-more btn-sm'>
						Load more
					</Button>
				)}
				{this.state.nextToken != null && this.state.filtered ? (
					<Button onClick={this.loadMore} type='button' className='load-more btn-sm'>
						Load more Results
					</Button>
				) : null}
			</section>
		)
	}
}

export default ReferralUserSignups
